import {useEffect, useState} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import {Center, Loader, Stack} from '@mantine/core';

// Redux
import {store} from 'store';
import {clearUserData} from 'store/actions';

// Global utils
import AuthUtils from 'utils/auth';
import {connectOnlineSocket} from 'utils/socket';
import {isWebClient} from 'utils/buildMode';
import Text from 'components/core/Text';

// We will try to render the content first when sessionToken exist and then check if the user is authenticated afterwards
// This is done to smoothly transition in the content even the user's connection is slow
// If we decides to authenticate first, the transition will apply on the empty space while the user is being authenticated
const RequireAuthRoute = ({children, debug}) => {
	const isSessionExist = !!AuthUtils.sessionToken;
	const [isWebSessionChecking, setIsWebSessionChecking] = useState(isWebClient && isSessionExist && !debug);
	// const isSessionExist = true;
	const navigate = useNavigate();
	const location = useLocation();
	// Lifecycle Hooks
	useEffect(() => {
		!debug && AuthUtils.isSessionValid().then(() => {
			if (isWebClient) connectOnlineSocket(AuthUtils.sessionToken);
			if (!store.getState().reducerUser?.selectedLocation?.id) {
				throw new Error('NO_OUTLET_SELECTED');
			}
			setIsWebSessionChecking(false);
		}).catch(e => {
			if (e?.response?.status === 401) {
				AuthUtils.revokeCurrentSession().catch(() => null).finally(() => {
					navigate(isWebClient ? '/auth?reason=session-expired' : '/auth', {replace: true});
				});
			} else if (e?.message === 'TOKEN_DONT_EXIST') {
				navigate('/auth', {replace: true});
			} else if (e?.message === 'NO_OUTLET_SELECTED') {
				Cookies.remove(AuthUtils.sessionStorageKey);
				store.dispatch(clearUserData());
				setTimeout(() =>
					navigate('/auth', {replace: true})
				, 100);
			} else {
				setIsWebSessionChecking(false);
			}
		});
	}, [location]);
	// Render
	if (isWebSessionChecking) {
		return (
			<Center style={{minHeight: '100vh'}}>
				<Stack
					align="center"
					spacing="md">
					<Loader />
					<Text>Checking your Fresto session…</Text>
				</Stack>
			</Center>
		);
	}
	if (debug || isSessionExist) {
		return children;
	} else if (isSessionExist === null) {
		return <></>;
	}
	return null;
};

RequireAuthRoute.defaultProps = {
	debug: false,
};

RequireAuthRoute.propTypes = {
	children: PropTypes.node,
	debug: PropTypes.bool,
};

export default RequireAuthRoute;
